(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7707],{

/***/ 55105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const lodash_1 = __importDefault(__webpack_require__(96486));
const assert_1 = __importDefault(__webpack_require__(27596));
const constants_1 = __webpack_require__(13294);
const LISTED_PRODUCT_TYPE_PATHS = {
    combined: 'hospital-extras-bundle',
    extras: 'extras-cover',
    hospital: 'hospital-cover',
    package: 'hospital-extras-packages',
};
function getProductUrl(args) {
    const { errorUrl, productId, rawUrl } = args || { errorUrl: undefined, productId: undefined, rawUrl: undefined };
    (0, assert_1.default)(lodash_1.default.isString(rawUrl), 'rawUrl must be a string');
    (0, assert_1.default)(lodash_1.default.isString(productId), 'productId must be a string');
    (0, assert_1.default)(lodash_1.default.isString(errorUrl), 'errorUrl must be a string');
    const type = lodash_1.default.findKey(constants_1.PRODUCTS_BY_TYPE, (products) => lodash_1.default.includes(products, productId));
    const parentProductId = lodash_1.default.findKey(constants_1.PRODUCTS_BY_PARENT, (products) => lodash_1.default.includes(products, productId));
    if (lodash_1.default.isUndefined(type) || lodash_1.default.isUndefined(productId)) {
        return errorUrl;
    }
    const productUrl = (0, lodash_1.default)(rawUrl)
        .replace(':type', LISTED_PRODUCT_TYPE_PATHS[type])
        .replace(':id', parentProductId || lodash_1.default.replace(productId, /(\b-excess-)[0-9]*/, ''));
    return productUrl;
}
module.exports = {
    getProductUrl,
};


/***/ }),

/***/ 1117:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/choosable/picker",
      function () {
        return __webpack_require__(21337);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9788:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/offer-tag.f54e60b9.svg","height":37,"width":76});

/***/ }),

/***/ 21337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/utils/bundle/index.ts
var bundle = __webpack_require__(57107);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/ambulance-section/index.tsx + 2 modules
var ambulance_section = __webpack_require__(53138);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/base-bundle-section/index.tsx + 1 modules
var base_bundle_section = __webpack_require__(23996);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/utils/get-frequency-options/index.tsx
var get_frequency_options = __webpack_require__(26089);
// EXTERNAL MODULE: ./src/client/utils/get-scale-options/index.tsx
var get_scale_options = __webpack_require__(94562);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/basic-details-form/index.tsx








var BasicDetailsForm = function(param) {
    var defaultValues = param.defaultValues, handleSubmit = param.handleSubmit;
    var frequencyOptions = (0,get_frequency_options/* default */.Z)({
        endText: "ly",
        format: fp.upperFirst
    });
    var scaleOptions = (0,get_scale_options/* default */.Z)({});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm.Formik, {
        initialValues: defaultValues,
        onSubmit: handleSubmit,
        children: function(formik) {
            return(// @ts-expect-error - Automatic, Please fix when editing this file
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Form */.l0, {
                onSubmit: formik.onSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* FormikField */.Ub, {
                        label: "Cover type",
                        name: "scale",
                        options: scaleOptions,
                        onBlur: formik.handleBlur,
                        onChange: formik.handleChange,
                        type: "dropdown"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* FormikField */.Ub, {
                        label: "Living in",
                        name: "state",
                        options: ahm_constants/* default.STATE_OPTIONS */.Z.STATE_OPTIONS,
                        onBlur: formik.handleBlur,
                        onChange: formik.handleChange,
                        type: "dropdown"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* FormikField */.Ub, {
                        label: "Paying",
                        name: "frequency",
                        options: frequencyOptions,
                        onBlur: formik.handleBlur,
                        onChange: formik.handleChange,
                        type: "dropdown"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                        variant: "wide",
                        type: "submit",
                        onClick: formik.handleSubmit,
                        children: "Choose my cover"
                    })
                ]
            }));
        }
    });
};
/* harmony default export */ var basic_details_form = (BasicDetailsForm);

;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/basic-details-modal/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1rem;\n\n  @media (min-width: ",
        ") {\n    max-width: 26rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 800;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var ModalContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-26ebad3a-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.lg;
});
var SkipThisWrapper = (0,styled_components_browser_esm["default"])(ahm_ui/* SpacerWrapper */.Cj).withConfig({
    componentId: "sc-26ebad3a-1"
})(_templateObject1());
var SkipThis = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-26ebad3a-2"
})(_templateObject2());
var BasicDetailsModal = function(param) {
    var form = param.form, isOpen = param.isOpen, toggleModal = param.toggleModal;
    var handleSubmit = form.handleSubmit, defaultValues = form.defaultValues;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Modal */.u_, {
        ariaLabelledBy: "basic-details-modal-title",
        isOpen: isOpen,
        toggleModal: toggleModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                    variant: "marginBottomSpacer9",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                        id: "basic-details-modal-title",
                        children: "Show me choosable extra covers for..."
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_details_form, {
                    defaultValues: defaultValues,
                    handleSubmit: handleSubmit
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipThisWrapper, {
                    variant: [
                        "marginBottomSpacer9",
                        "marginTopSpacer9"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipThis, {
                        onClick: toggleModal,
                        children: "Skip this"
                    })
                })
            ]
        })
    });
};
BasicDetailsModal.defaultProps = {
    isOpen: true
};
/* harmony default export */ var basic_details_modal = (BasicDetailsModal);

// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/bundles-section/index.tsx + 3 modules
var bundles_section = __webpack_require__(2058);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/chicken-dinner-section/images/chicken-and-chips.svg
/* harmony default export */ var chicken_and_chips = ({"src":"/_next/static/media/chicken-and-chips.36d0db1e.svg","height":124,"width":160});
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/chicken-dinner-section/data.ts


var _URLS = ahm_constants/* default.URLS */.Z.URLS, PRODUCT_LISTING_EXTRAS = _URLS.SALES.PRODUCT_LISTING_EXTRAS;
var data = {
    tiles: [
        {
            cta: {
                isClickable: true,
                title: "View all extras cover",
                to: PRODUCT_LISTING_EXTRAS
            },
            image: {
                alt: "",
                src: chicken_and_chips.src
            },
            summary: "If nothing here tickles your fancy, check out our other cover options.",
            title: "Want more extras?"
        }, 
    ]
};
/* harmony default export */ var chicken_dinner_section_data = (data);

// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/chicken-dinner-section/styles.module.sass
var styles_module = __webpack_require__(91858);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/chicken-dinner-section/index.tsx





var tiles = chicken_dinner_section_data.tiles;
var ChickenDinnerSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Section */.$0, {
        variant: [
            "paddingTopSpacer2",
            (styles_module_default()).section
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* FeaturePanel */.JK, {
            tiles: tiles,
            title: ""
        })
    });
};
/* harmony default export */ var chicken_dinner_section = (ChickenDinnerSection);

// EXTERNAL MODULE: ./src/client/actions/choosable/index.ts
var choosable = __webpack_require__(67687);
// EXTERNAL MODULE: ./src/client/actions/customer/index.ts
var customer = __webpack_require__(91395);
// EXTERNAL MODULE: ./src/client/actions/footer/index.ts
var footer = __webpack_require__(21474);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/utils/get-choosable-all-included-services/index.ts
var get_choosable_all_included_services = __webpack_require__(5684);
// EXTERNAL MODULE: ./src/client/images/hand-right.svg
var hand_right = __webpack_require__(80136);
// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/header-section/styles.module.sass
var header_section_styles_module = __webpack_require__(769);
var header_section_styles_module_default = /*#__PURE__*/__webpack_require__.n(header_section_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/header-section/index.tsx

function header_section_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n"
    ]);
    header_section_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_section_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  max-width: 44.25rem;\n  padding: 0 1rem;\n"
    ]);
    header_section_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-73d4b236-0"
})(header_section_templateObject());
var StyledTypeWrapper = (0,styled_components_browser_esm["default"])(ahm_ui/* TypeWrapper */.f3).withConfig({
    componentId: "sc-73d4b236-1"
})(header_section_templateObject1());
var HeaderSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                src: hand_right/* default.src */.Z.src,
                alt: "Illustration of a hand",
                className: (header_section_styles_module_default()).image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTypeWrapper, {
                variant: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                        variant: [
                            "marginTopSpacer1",
                            "marginBottomSpacer9"
                        ],
                        children: "Choosable extras"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Span */.Dr, {
                        children: [
                            "Prefer to choose the extras you know you’ll need? With our choosable range you can",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                children: "customise your extras around your lifestyle."
                            }),
                            " Just start with the base teeth bundle and then add on the bundles you need, with muscle & bone, eyes, and wellbeing bundles to choose from. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Now that’s simple!"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var header_section = (HeaderSection);

// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/join-bar/components/bundle-chosen-view/index.tsx + 1 modules
var bundle_chosen_view = __webpack_require__(10269);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/join-bar/components/no-bundle-chosen-view/index.tsx
var no_bundle_chosen_view = __webpack_require__(56242);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/join-bar/images/personalise-your-price.svg
/* harmony default export */ var personalise_your_price = ({"src":"/_next/static/media/personalise-your-price.9598cf02.svg","height":75,"width":100});
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/join-bar/styles.module.sass
var join_bar_styles_module = __webpack_require__(14120);
var join_bar_styles_module_default = /*#__PURE__*/__webpack_require__.n(join_bar_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/components/join-bar/index.tsx

function join_bar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: -0.5rem;\n  margin-top: -0.5rem;\n  position: sticky;\n  transition: transform 0.3s;\n  transform: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    join_bar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-33fb5a19-0"
})(join_bar_templateObject(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "none" : "translateY(100%)";
}, function(param) {
    var theme = param.theme;
    return theme.zIndices.footer;
});
var JoinBar = function(param) {
    var customer = param.customer, effectiveDate = param.effectiveDate, isVisible = param.isVisible, prices = param.prices, selectedBundles = param.selectedBundles;
    var isBundleChosen = (0,fp.size)(selectedBundles) > 0;
    var productId = (0,bundle/* determineProductIdFromBundles */.F)(selectedBundles);
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        "data-testid": "join-bar",
        isVisible: isVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* BorderGridContainer */.sO, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* GridBox */.zc, {
                padding: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (join_bar_styles_module_default()).viewWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                            xs: true,
                            sm: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                className: (join_bar_styles_module_default()).personaliseYourPrice,
                                src: personalise_your_price.src,
                                alt: "Personalise Your Price",
                                width: "64px",
                                height: "48px"
                            })
                        }),
                        isBundleChosen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bundle_chosen_view/* default */.Z, {
                            customer: customer,
                            effectiveDate: effectiveDate,
                            prices: prices,
                            productId: productId
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(no_bundle_chosen_view/* default */.Z, {})
                    ]
                })
            })
        })
    }));
};
JoinBar.defaultProps = {
    effectiveDate: null,
    isVisible: false,
    prices: null
};
/* harmony default export */ var join_bar = (JoinBar);

// EXTERNAL MODULE: ./src/client/components/loading-spinner/index.tsx
var loading_spinner = __webpack_require__(30950);
// EXTERNAL MODULE: ./src/client/selectors/make-select-has-all-required-products-loaded/index.ts
var make_select_has_all_required_products_loaded = __webpack_require__(42070);
// EXTERNAL MODULE: ./src/client/components/offers/banner/index.tsx + 2 modules
var banner = __webpack_require__(9010);
// EXTERNAL MODULE: ./src/client/actions/price/index.ts
var price = __webpack_require__(77061);
// EXTERNAL MODULE: ./src/client/models/price/index.ts
var models_price = __webpack_require__(2798);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/index.tsx + 7 modules
var pricing_drawer = __webpack_require__(87022);
// EXTERNAL MODULE: ./src/client/actions/product/index.ts
var product = __webpack_require__(15311);
// EXTERNAL MODULE: ./src/client/selectors/select-choosable-comparer-product-id/index.ts
var select_choosable_comparer_product_id = __webpack_require__(13545);
// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./src/client/selectors/select-effective-date-override/index.ts
var select_effective_date_override = __webpack_require__(89298);
// EXTERNAL MODULE: ./src/client/selectors/select-has-partner-referrer/index.ts
var select_has_partner_referrer = __webpack_require__(93830);
// EXTERNAL MODULE: ./src/client/selectors/select-is-premium-change-enabled/index.ts
var select_is_premium_change_enabled = __webpack_require__(45424);
// EXTERNAL MODULE: ./src/client/selectors/select-target-segment/index.ts
var select_target_segment = __webpack_require__(80622);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/components/snake-separator/index.tsx + 1 modules
var snake_separator = __webpack_require__(82024);
// EXTERNAL MODULE: ./src/client/pages/choosable/pages/picker/hooks/use-intersection-observer/index.ts
var use_intersection_observer = __webpack_require__(60529);
;// CONCATENATED MODULE: ./src/client/pages/choosable/pages/picker/index.tsx

function picker_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: hidden;\n"
    ]);
    picker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function picker_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    picker_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function picker_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 0.1rem solid ",
        ";\n"
    ]);
    picker_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 215px;\n  position: absolute;\n  right: -30px;\n  top: 6px;\n  transform: scaleX(-1);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






































var picker_Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27b039a1-0"
})(picker_templateObject());
var SnakeWithHandWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27b039a1-1"
})(picker_templateObject1());
var OfferBannerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27b039a1-2"
})(picker_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.purple;
});
var HandImage = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-27b039a1-3"
})(_templateObject3());
var PickerPage = function(param) {
    var actions = param.actions, areAllProductsLoaded = param.areAllProductsLoaded, _choosableComparerProductId = param.choosableComparerProductId, choosableComparerProductId = _choosableComparerProductId === void 0 ? undefined : _choosableComparerProductId, customer = param.customer, _effectiveDate = param.effectiveDate, effectiveDate = _effectiveDate === void 0 ? undefined : _effectiveDate, isPartnerReferral = param.isPartnerReferral, _prices = param.prices, prices = _prices === void 0 ? undefined : _prices, _products = param.products, products = _products === void 0 ? undefined : _products, targetSegment = param.targetSegment;
    var hasSetBasicDetails = customer.hasSetBasicDetails;
    var ref = (0,react.useState)(!hasSetBasicDetails), isModalOpen = ref[0], setIsModalOpen = ref[1];
    // @ts-expect-error - Automatic, Please fix when editing this file
    var search = (0,router.useRouter)().search;
    var searchParams = new URLSearchParams(search);
    var modal = searchParams.get("modal");
    (0,react.useEffect)(function() {
        if (modal === "open") {
            setIsModalOpen(true);
        }
    }, [
        modal
    ]);
    var closeModal = function() {
        setIsModalOpen(false);
    };
    var defaultValues = {
        frequency: customer.frequency,
        scale: customer.scale,
        state: customer.state
    };
    var handleSubmitBasicDetailsForm = function(param) {
        var frequency = param.frequency, scale = param.scale, state = param.state;
        if (frequency !== defaultValues.frequency) {
            actions.customer.changeFrequency(frequency);
        }
        if (scale !== defaultValues.scale) {
            actions.customer.changeScale(scale);
        }
        if (state !== defaultValues.state) {
            actions.customer.changeState(state);
        }
        closeModal();
    };
    var ref1 = (0,react.useState)([]), selectedBundles = ref1[0], setSelectedBundles = ref1[1];
    var handleBundleSelection = function(bundles) {
        setSelectedBundles(bundles);
        actions.choosable.setChoosableComparerProductId((0,bundle/* determineProductIdFromBundles */.F)(bundles));
    };
    (0,react.useEffect)(function() {
        actions.product.load(ui.CHOOSABLE_PRODUCTS);
    }, [
        actions
    ]);
    // Use this key composed of relevant customer data to indicate when customer data
    // changes and to hence trigger the useEffect to load prices
    var customerKey = models_price/* default.getKey */.Z.getKey("", customer, {
        date: effectiveDate
    });
    (0,react.useEffect)(function() {
        actions.price.load(ui.CHOOSABLE_PRODUCTS, {
            customer: customer
        }, {
            date: effectiveDate
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        actions,
        customerKey,
        effectiveDate
    ]);
    (0,react.useEffect)(function() {
        if (areAllProductsLoaded) {
            setSelectedBundles((0,bundle/* determineBundlesFromProductId */.M)(choosableComparerProductId));
        }
    }, [
        areAllProductsLoaded,
        choosableComparerProductId
    ]);
    // Determine if the join bar should be showing
    var joinBarTriggerRef = (0,react.useRef)(null);
    var ref2 = (0,use_intersection_observer/* default */.Z)(joinBarTriggerRef, {
        freezeOnceVisible: true
    }), observer = ref2.entry, isIntersectionObserverSupported = ref2.isSupported;
    var isJoinBarVisible = !isIntersectionObserverSupported || (0,fp.getOr)(false, "isIntersecting", observer);
    (0,react.useEffect)(function() {
        actions.footer.setAdjustFooterLinks(isJoinBarVisible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isJoinBarVisible
    ]);
    // Prepare data for rendering bundles
    var allIncludedServices = (0,get_choosable_all_included_services/* default */.Z)(products);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
                titleTemplate: ui.SHORT_PAGE_TITLE_TEMPLATE,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "ahm choosable | health insurance extras"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Build your extras health cover around what you know you need, and only ever pay for the extras bundles you’ll use. Start with the base bundle, then tailor from there."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_details_modal, {
                form: {
                    defaultValues: defaultValues,
                    handleSubmit: handleSubmitBasicDetailsForm
                },
                isOpen: isModalOpen,
                toggleModal: closeModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* BorderGridContainer */.sO, {
                hideBorderTop: true,
                children: [
                    !isPartnerReferral && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferBannerWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, {
                            filterProductId: choosableComparerProductId || (0,fp.flow)(fp.values, fp.head, (0,fp.get)("id"))(products),
                            targetSegment: targetSegment
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* GridBox */.zc, {
                        padding: "0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_section, {}),
                            !areAllProductsLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(picker_Wrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snake_separator/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base_bundle_section/* default */.Z, {
                                        allIncludedServices: allIncludedServices,
                                        scale: customer.scale
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ambulance_section/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SnakeWithHandWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snake_separator/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                                                xs: true,
                                                sm: true,
                                                lg: true,
                                                df: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HandImage, {
                                                    src: hand_right/* default.src */.Z.src,
                                                    alt: "Illustration of a hand"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        ref: joinBarTriggerRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(bundles_section/* default */.Z, {
                                                allIncludedServices: allIncludedServices,
                                                scale: customer.scale,
                                                selectedBundles: selectedBundles,
                                                setSelectedBundles: handleBundleSelection
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chicken_dinner_section, {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_drawer/* default */.Z, {
                isProductWithHospitalServices: false,
                showIncomeOptions: true
            }),
            areAllProductsLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(join_bar, {
                customer: customer,
                effectiveDate: effectiveDate,
                isVisible: isJoinBarVisible,
                prices: prices,
                selectedBundles: selectedBundles
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        // @ts-expect-error - Automatic, Please fix when editing this file
        areAllProductsLoaded: (0,make_select_has_all_required_products_loaded/* default */.Z)(ui.CHOOSABLE_PRODUCTS)(state),
        // @ts-expect-error - Automatic, Please fix when editing this file
        choosableComparerProductId: (0,select_choosable_comparer_product_id/* default */.Z)(state),
        customer: (0,select_customer/* default */.Z)(state),
        effectiveDate: (0,select_effective_date_override/* default */.Z)(state),
        isPartnerReferral: (0,select_has_partner_referrer/* default */.Z)(state),
        isPremiumChangeEnabled: (0,select_is_premium_change_enabled/* default */.Z)(state),
        prices: state.price.data,
        products: state.product.data,
        targetSegment: (0,select_target_segment/* default */.Z)(state),
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            choosable: (0,redux/* bindActionCreators */.DE)(choosable/* default */.Z, dispatch),
            customer: (0,redux/* bindActionCreators */.DE)(customer/* default */.Z, dispatch),
            footer: (0,redux/* bindActionCreators */.DE)(footer/* default */.Z, dispatch),
            price: (0,redux/* bindActionCreators */.DE)(price/* default */.Z, dispatch),
            product: (0,redux/* bindActionCreators */.DE)(product/* default */.Z, dispatch)
        }
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
/* harmony default export */ var picker = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(PickerPage));


;// CONCATENATED MODULE: ./pages/choosable/picker/index.page.ts

/* harmony default export */ var index_page = (picker);


/***/ }),

/***/ 15311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23094);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43735);



/**
 * Load products into state.
 *
 * @param {string|string[]} productIds - One or a list of product ids.
 * @returns {object} Action.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
function load(productIds) {
    var array = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isString)(productIds) ? [
        productIds
    ] : productIds;
    return {
        productIds: array,
        // @ts-expect-error - Automatic, Please fix when editing this file
        promise: function(api) {
            return _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].loadProducts */ .Z.loadProducts(api, array);
        },
        types: [
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD */ .F9,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_SUCCESS */ .cx,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_FAIL */ .w2
        ]
    };
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    load: load
});


/***/ }),

/***/ 13535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71439);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28937);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment howToFields on HowTo {\n    id: _id\n    name\n    slogan: sloganRaw\n    steps {\n      name\n      description: descriptionRaw\n      ",
        "\n      ",
        "\n    }\n    ",
        "\n    importance\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__.gql)(_templateObject(), _constants__WEBPACK_IMPORTED_MODULE_1__/* .GRAPHQL.IMAGE_OBJECT */ .gQ.IMAGE_OBJECT, _constants__WEBPACK_IMPORTED_MODULE_1__/* .GRAPHQL.URL_OBJECT */ .gQ.URL_OBJECT, _constants__WEBPACK_IMPORTED_MODULE_1__/* .GRAPHQL.URL_OBJECT */ .gQ.URL_OBJECT));


/***/ }),

/***/ 51413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _image_url_builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36175);


var getImageAttributes = function(param) {
    var imageObject = param.imageObject, height = param.height, width = param.width;
    var image = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("image", imageObject);
    if (!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("asset", image)) {
        return null;
    }
    var caption = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)("", "caption", imageObject);
    return {
        alt: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNull)(caption) ? "" : caption,
        // @ts-expect-error - Automatic, Please fix when editing this file
        src: (0,_image_url_builder__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(image).height(height).width(width).url()
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getImageAttributes);


/***/ }),

/***/ 36175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35420);
/* harmony import */ var _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6465);


/**
 * @param {object} source - Object from Sanity that contains information about the image.
 * @returns {object} Object that can be called with many functions to override behaviour.
 * To override sizing while preserving aspect ratio you can set either height or width to undefined.
 * If you currently have SVG sources, upload a jpg, or just set `.format('jpg')` to test your sizing is reasonable.
 * NOTE: for more detail on the usage of the imageUrlBuilder see https://www.sanity.io/docs/image-url.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var imageUrlBuilder = function(source) {
    return _ahmdigital_logic_lib_utils_sanity_image_url_builder__WEBPACK_IMPORTED_MODULE_0___default()({
        dataset: _client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dataset */ .Z.dataset,
        projectId: _client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].projectId */ .Z.projectId
    })(source);
};
/* harmony default export */ __webpack_exports__["Z"] = (imageUrlBuilder);


/***/ }),

/***/ 30950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90937);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_3__);




/**
 * @deprecated If you need to display a transition state for the entire content of a page please
 * prefer LoadingContent to avoid breaking accessibility rules.
 */ var LoadingSpinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default().section),
        "data-testid": "loading-spinner",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Section */ .$0, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Wrapper */ .im, {
                size: "large",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$j, {})
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingSpinner);


/***/ }),

/***/ 60202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

// @ts-expect-error - Automatic, Please fix when editing this file
var getCodeType = function(offer) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("canBeRedeemedWithPromoCode[0].codeType", offer);
};
/* harmony default export */ __webpack_exports__["Z"] = (getCodeType);


/***/ }),

/***/ 22979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13294);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_code_type__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60202);


// @ts-expect-error - Automatic, Please fix when editing this file
var getIsReferralCodeType = function(offer) {
    return (0,_get_code_type__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(offer) === (_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0___default().OFFER_CODE_TYPE.REFERRAL);
};
/* harmony default export */ __webpack_exports__["Z"] = (getIsReferralCodeType);


/***/ }),

/***/ 8235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahmdigital_offers_lib_model_offers_find_active_by_target_segment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22021);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _cms_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28937);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93590);
/* harmony import */ var _cms_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6465);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10453);
/* harmony import */ var _use_get_all_offers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41684);

// @ts-expect-error - Automatic, Please fix when editing this file







var useGetActivePromoOffer = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _referrerAttribution = ref.referrerAttribution, referrerAttribution = _referrerAttribution === void 0 ? null : _referrerAttribution, _targetSegment = ref.targetSegment, targetSegment = _targetSegment === void 0 ? _cms_constants__WEBPACK_IMPORTED_MODULE_3__/* .TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE */ .TZ.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE : _targetSegment, _skip = ref.skip, skip = _skip === void 0 ? false : _skip;
    var isSwagReferrer = referrerAttribution === _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_4__.SWAG_SOURCE_CODE;
    var useLiveFiltering = _cms_client__WEBPACK_IMPORTED_MODULE_5__/* ["default"].useLiveFiltering */ .Z.useLiveFiltering, asAtDate = _cms_client__WEBPACK_IMPORTED_MODULE_5__/* ["default"].asAtDate */ .Z.asAtDate, asAtTime = _cms_client__WEBPACK_IMPORTED_MODULE_5__/* ["default"].asAtTime */ .Z.asAtTime;
    var effectiveDate = // @ts-expect-error - Automatic, Please fix when editing this file
    useLiveFiltering && asAtDate && asAtDate !== _cms_constants__WEBPACK_IMPORTED_MODULE_3__/* .NOW */ .Kp ? moment__WEBPACK_IMPORTED_MODULE_2___default()("".concat(asAtDate, " ").concat(asAtTime), "".concat(_ahm_constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].DATE_FORMAT.STANDARD */ .Z.DATE_FORMAT.STANDARD, " HH:mm")) : moment__WEBPACK_IMPORTED_MODULE_2___default()();
    var ref1 = (0,_use_get_all_offers__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        skip: skip
    }), allOffers = ref1.allOffers, loading = ref1.loading;
    // Do this last to prevent a rule-of-hooks lint failure
    if (skip) {
        return {
            activeOffers: null,
            loading: false
        };
    }
    if (isSwagReferrer) {
        var swagOffers = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.filter)(function(offer) {
            var ref;
            return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(offer === null || offer === void 0 ? void 0 : (ref = offer.identifier) === null || ref === void 0 ? void 0 : ref.current, _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_4__.SWAG_OFFER_IDS);
        }, allOffers);
        return {
            activeOffers: swagOffers,
            loading: loading
        };
    }
    // Only returns only last three active offers as we only want to display the last three that are active and this reduces additional filtering later on.
    var activeOffers = (0,_ahmdigital_offers_lib_model_offers_find_active_by_target_segment__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(allOffers, targetSegment, {
        effectiveDate: effectiveDate.toDate()
    }).slice(-3);
    return {
        activeOffers: activeOffers,
        loading: loading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetActivePromoOffer);


/***/ }),

/***/ 41684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_get_all_offers; },
  "p": function() { return /* binding */ generateOffersQuery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/index.js
var core = __webpack_require__(71439);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/get-melbourne-timezone-moment/index.js
var get_melbourne_timezone_moment = __webpack_require__(80605);
var get_melbourne_timezone_moment_default = /*#__PURE__*/__webpack_require__.n(get_melbourne_timezone_moment);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/offers/lib/model/offer/is-expired/index.js
var is_expired = __webpack_require__(33873);
// EXTERNAL MODULE: ./src/client/cms/constants/index.ts
var constants = __webpack_require__(28937);
// EXTERNAL MODULE: ./src/client/cms/fragments/how-to-fields/index.ts
var how_to_fields = __webpack_require__(13535);
// EXTERNAL MODULE: ./src/client/logging/index.ts
var logging = __webpack_require__(99846);
// EXTERNAL MODULE: ./src/client/components/offers/logic/use-offer-query/index.ts
var use_offer_query = __webpack_require__(34914);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/offers/lib/model/offer/get-validation-errors/get-definition-errors/index.js
var get_definition_errors = __webpack_require__(15237);
;// CONCATENATED MODULE: ./src/client/components/offers/logic/validate-offer/index.ts

// @ts-expect-error - Automatic, Please fix when editing this file


// @ts-expect-error - Automatic, Please fix when editing this file
var validateOffer = function(offer) {
    var errors = (0,get_definition_errors/* default */.Z)(offer);
    if (!(0,fp.isEmpty)(errors)) {
        logging/* default.getLogger */.Z.getLogger().error("Offer validation error", {
            errors: errors,
            offer: offer
        });
    }
};
/* harmony default export */ var validate_offer = (validateOffer);

;// CONCATENATED MODULE: ./src/client/components/offers/logic/use-get-all-offers/index.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query AllOffer {\n    allOffer",
        " {\n      _id\n      _type\n      id: _id\n      _createdAt\n      ",
        "\n      canBeRedeemedWithPromoCode {\n        code {\n          current\n        }\n        codeType\n        description: descriptionRaw\n      }\n      minimumGapInCoverDays\n      detailsTeaser\n      targetsSegments {\n        identifier {\n          current\n        }\n      }\n      identifier {\n        current\n      }\n      ",
        "\n      offerTypes {\n        _id\n        name\n        identifier {\n          current\n        }\n        slogan: sloganRaw\n        description: descriptionRaw\n        givesAccessToOneOfRewards {\n          identifier {\n            current\n          }\n          name\n        }\n        fulfilledAfterDays\n        ",
        "\n        ",
        "\n        ",
        "\n        summary\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// @ts-expect-error - Automatic, Please fix when editing this file






var ORGANISATION_FIELDS = "\n  offeredByOrganization {\n    name\n    identifier {\n      current\n    }\n    logo {\n      ".concat(constants/* GRAPHQL.IMAGE_FIELDS */.gQ.IMAGE_FIELDS, "\n    }\n    termsAndConditions:termsAndConditionsRaw\n    isFulfilledUsingSourceCodes {\n      appliesToServiceChannel {\n        name\n      }\n      code {\n        current\n      }\n    }\n  }\n");
var HOW_TO_FIELDS = "\n  howTo {\n    ...howToFields\n  }\n";
// @ts-expect-error - Automatic, Please fix when editing this file
var generateOffersQuery = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, filter = ref.filter, _withOrganisation = ref.withOrganisation, withOrganisation = _withOrganisation === void 0 ? false : _withOrganisation, _withHowTo = ref.withHowTo, withHowTo = _withHowTo === void 0 ? false : _withHowTo;
    return (0,core.gql)(_templateObject(), filter ? "(where: ".concat(filter, ")") : "", constants/* GRAPHQL.RELEASE */.gQ.RELEASE, withHowTo ? HOW_TO_FIELDS : "", constants/* GRAPHQL.OFFER_TYPE_CONDITIONS */.gQ.OFFER_TYPE_CONDITIONS, withOrganisation ? ORGANISATION_FIELDS : "", constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT, withHowTo ? how_to_fields/* default */.Z : "");
};
var useGetAllOffers = function() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _skip = _param.skip, skip = _skip === void 0 ? false : _skip, opts = (0,_object_without_properties/* default */.Z)(_param, [
        "skip"
    ]);
    // @ts-expect-error - Automatic, Please fix when editing this file
    var ref = (0,use_offer_query/* default */.Z)(generateOffersQuery(opts), {
        skip: skip
    }), data = ref.data, error = ref.error, loading = ref.loading;
    if (skip) {
        return {
            allOffers: [],
            loading: false
        };
    }
    var allOffers = (0,fp.get)("allOffer", data);
    if (!loading && error) {
        logging/* default.getLogger */.Z.getLogger().error("graphql::error - Failed to get offers from CMS", {
            error: error,
            opts: opts
        });
        return {
            allOffers: [],
            loading: false
        };
    }
    // Validate all offers but don't bother for offers that are out of date
    var now = get_melbourne_timezone_moment_default()();
    // eslint-disable-next-line lodash-fp/no-unused-result
    (0,fp.flow)((0,fp.reject)(function(offer) {
        return (0,is_expired/* default */.Z)(offer, {
            effectiveDate: now
        });
    }), (0,fp.forEach)((0,fp.unary)(validate_offer)))(allOffers);
    return {
        allOffers: allOffers,
        loading: loading
    };
};
/* harmony default export */ var use_get_all_offers = (useGetAllOffers);



/***/ }),

/***/ 34914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46829);
/* harmony import */ var _cms_utils_unique_content_with_draft_precedence__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92002);





// @ts-expect-error - Automatic, Please fix when editing this file
var useOfferQuery = function(gqlQuery, options) {
    var response = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__.useQuery)(gqlQuery, options);
    var data = response.data;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, response), {
        data: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNil)(data) ? data : {
            allOffer: (0,_cms_utils_unique_content_with_draft_precedence__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("allOffer", response.data))
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useOfferQuery);


/***/ }),

/***/ 44724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_shared_replace_placeholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40844);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_shared_replace_placeholder__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_shared_replace_placeholder__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99846);






var placeholderSerializer = function(param) {
    var offer = param.offer, offerTypeId = param.offerTypeId, placeholders = param.placeholders, rewards = param.rewards;
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    function(value) {
        var matchedPlaceholder = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.find)({
            _id: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("node._ref", value)
        }, placeholders);
        var placeholderId = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("identifier.current", matchedPlaceholder);
        var result = _ahmdigital_logic_lib_content_offers_shared_replace_placeholder__WEBPACK_IMPORTED_MODULE_4___default()({
            offer: offer,
            offerTypeId: offerTypeId,
            placeholderId: placeholderId,
            rewards: rewards
        });
        if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isNull)(result)) {
            _logging__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getLogger */ .Z.getLogger().error("Failed to replace offer terms and conditions placeholder", {
                matchedPlaceholder: matchedPlaceholder,
                offer: offer,
                value: value
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Strong */ .cK, {
                children: [
                    "[[PLACEHOLDER:",
                    placeholderId,
                    "]]"
                ]
            });
        }
        return result;
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (placeholderSerializer);


/***/ }),

/***/ 95897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91282);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_header__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_unqualified_get_header__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_offer_end_summary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59182);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_offer_end_summary__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_unqualified_get_offer_end_summary__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85224);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_unqualified_get_promo_code__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code_description__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72679);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code_description__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_unqualified_get_promo_code_description__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_subtext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52068);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_subtext__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_unqualified_get_subtext__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _logic_get_is_referral_code_type__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22979);
/* harmony import */ var _utils_get_offer_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88290);








var getOrNull = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null);
var getContentForOffer = function(offer, referralCode) {
    var image = (0,_utils_get_offer_image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(offer);
    var header = _ahmdigital_logic_lib_content_offers_unqualified_get_header__WEBPACK_IMPORTED_MODULE_1___default()(offer);
    var subtext = _ahmdigital_logic_lib_content_offers_unqualified_get_subtext__WEBPACK_IMPORTED_MODULE_5___default()(offer, false);
    var sublist = _ahmdigital_logic_lib_content_offers_unqualified_get_subtext__WEBPACK_IMPORTED_MODULE_5___default()(offer, true);
    var isReferralCodeType = (0,_logic_get_is_referral_code_type__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(offer);
    var promoCode = isReferralCodeType ? referralCode : getOrNull("value", _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code__WEBPACK_IMPORTED_MODULE_3___default()(offer));
    var promoCodeDescription = getOrNull("value", _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code_description__WEBPACK_IMPORTED_MODULE_4___default()(offer));
    var subtextPrefix = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null, "offerTypes[0].summary", offer);
    var ends = _ahmdigital_logic_lib_content_offers_unqualified_get_offer_end_summary__WEBPACK_IMPORTED_MODULE_2___default()(offer);
    return {
        ends: ends,
        header: header,
        image: image,
        promoCode: promoCode,
        promoCodeDescription: promoCodeDescription,
        sublist: sublist,
        subtext: subtext,
        subtextPrefix: subtextPrefix
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getContentForOffer);


/***/ }),

/***/ 91186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahmdigital_offers_lib_model_offer_get_eligible_rewards__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14282);
/* harmony import */ var _ahmdigital_offers_lib_model_offer_get_upsell_applicable_rewards__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80336);
/* harmony import */ var _ahmdigital_offers_lib_model_offer_is_eligible__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40932);

// @ts-expect-error - Automatic, Please fix when editing this file

// @ts-expect-error - Automatic, Please fix when editing this file

// @ts-expect-error - Automatic, Please fix when editing this file

// @ts-expect-error - Automatic, Please fix when editing this file
var filterOffers = function(param) {
    var filterProductId = param.filterProductId, offers = param.offers;
    var scenarioForRewardEligibility = {
        productId: filterProductId
    };
    var eligibleOffers = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.filter)(function(offer) {
        return (0,_ahmdigital_offers_lib_model_offer_is_eligible__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(offer, scenarioForRewardEligibility);
    })(offers);
    var filteredOffers = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(eligibleOffers) ? (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.filter)(function(offer) {
        var eligibleRewards = (0,_ahmdigital_offers_lib_model_offer_get_eligible_rewards__WEBPACK_IMPORTED_MODULE_1__["default"])(offer, scenarioForRewardEligibility);
        var upsellApplicableRewards = (0,_ahmdigital_offers_lib_model_offer_get_upsell_applicable_rewards__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(offer, scenarioForRewardEligibility);
        var rewards = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(eligibleRewards) ? upsellApplicableRewards : eligibleRewards;
        return !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(rewards);
    })(offers) : eligibleOffers;
    return filteredOffers;
};
/* harmony default export */ __webpack_exports__["Z"] = (filterOffers);


/***/ }),

/***/ 88290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51413);


// @ts-expect-error - Automatic, Please fix when editing this file
var getOfferImage = function(offer) {
    var imageObject = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("offerTypes[0].imageObject", offer);
    return (0,_cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        imageObject: imageObject,
        width: 400
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (getOfferImage);


/***/ }),

/***/ 42070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99846);
/* harmony import */ var _select_raw_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96980);




var makeSelectHasAllRequiredProductsLoaded = function(productList) {
    return (0,reselect__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
        _select_raw_product__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
    ], function(products) {
        var loadedProductIds = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.flow)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.pick)([
            "data"
        ]), (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.flatMap)(lodash_fp__WEBPACK_IMPORTED_MODULE_1__.keys))(products);
        var allLoaded = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.every)(function(productId) {
            return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.includes)(productId, loadedProductIds);
        }, productList);
        if (!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("error", products))) {
            _logging__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getLogger */ .Z.getLogger().error("All required products haven’t loaded", {
                error: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.getOr)(null, "error", products)
            });
        }
        return allLoaded && (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.getOr)(false, "loading", products)) || !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.getOr)(null, "error", products));
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (makeSelectHasAllRequiredProductsLoaded);


/***/ }),

/***/ 25535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var getOrNull = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null, "referral.code");
var selectReferralCode = getOrNull;
/* harmony default export */ __webpack_exports__["Z"] = (selectReferralCode);


/***/ }),

/***/ 80622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cms_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28937);


// @ts-expect-error - Automatic, Please fix when editing this file
var selectTargetSegment = function(state) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(_cms_constants__WEBPACK_IMPORTED_MODULE_1__/* .TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE */ .TZ.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE, "referral.targetSegment", state);
};
/* harmony default export */ __webpack_exports__["Z"] = (selectTargetSegment);


/***/ }),

/***/ 90937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__LLK5Q"};

/***/ }),

/***/ 91858:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__D3w1w","heading":"styles_heading__MJGEY"};

/***/ }),

/***/ 769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","image":"styles_image__H23TE"};

/***/ }),

/***/ 14120:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","viewWrapper":"styles_viewWrapper__lFz_C","personaliseYourPrice":"styles_personaliseYourPrice__BiomQ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6950,8761,1372,6964,1849,9143,7022,5949,9774,2888,179], function() { return __webpack_exec__(1117); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);